import React, { PureComponent, memo } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import ToolkitProvider from "react-bootstrap-table2-toolkit";

import Tabla from "../../../components/UI/tabla/tablaSort";
import ModalSeguridad from "../../Seguridad/ModalSeguridad.jsx";
import {  Obtener_Estado_Active_Directory_Request } from '../../../request/ParametroRequest';
class CallCenterItfz extends PureComponent {
    state = {
        activoAD:false,
        columnasCallCenter: [
            {
                dataField: "Id",
                text: "Id",
                hidden: false,
                sort: true,
                editable: false,
                align: "left"
            },
            {  
                dataField: "Nombre",
                text: "Nombre",
                hidden: false,
                sort: true,
                editable: false
            },
        ],
        cellEdit: {},
        selectRow: {},
        rowStyle: {},
        keyField: "Id"
    }

    componentDidMount = async () => {
        const selectRow = {
            clickToSelect: true,
            onSelect: this.props.onRowSelect,
            mode: "radio",
            style: { background: "#e2f3f9" },
            hideSelectColumn: true
        };
        this.obtenerEstadoActiveDirectory();
        this.setState({ selectRow });
    }
    obtenerEstadoActiveDirectory = async () => {
        const response = await Obtener_Estado_Active_Directory_Request();
        if (response.Exitoso) {
            this.setState({ activoAD: response.Datos });
        }
        else {
            Notificacion.error(response.Mensaje);
        }
    };

    render() {
        const { Datos, listaCallCenter, menuId, opcionValidar, showModalSeguridad, paginaActual, onPageChange, onSizePerPageChange } = this.props;
        
        const { columnasCallCenter, keyField, cellEdit, selectRow, rowStyle, } = this.state;

        const rowEvents = { onDoubleClick: this.props.onDoubleClick };

        return (
            <ToolkitProvider
                keyField={keyField}
                data={this.state.listaCallCenter}
                columns={columnasCallCenter}
                search
            >
                {(props) => (
                    <>
                        <div className="container mt-3">
                            <div className="row">
                                <div className="col-12">
                                    <h1>{Datos.titulo}</h1>
                                </div>
                            </div>
                        </div>
                        <div className="container">
                            <Tabla
                                columnas={columnasCallCenter}
                                datos={listaCallCenter}
                                keyField={keyField}
                                modo={cellEdit}
                                rowEvents={rowEvents}
                                selectRow={selectRow}
                                rowStyle={rowStyle}
                                handleBorrar={this.props.handleBorrar}
                                handleNuevo={this.props.ingresarDatos}
                                handleActualizar={this.props.actualizarDatos}
                                paginaActual={paginaActual}
                                onPageChange={onPageChange}
                                onSizePerPageChange={onSizePerPageChange}
                            />
                        </div>
                        <ModalSeguridad
                            token={this.props.token}
                            menuId={menuId}
                            opcionId={opcionValidar}
                            show={showModalSeguridad}
                            onActionResult={this.props.onActionResultModal}
                            onHide={this.props.handleCerrarModal}
                            activoAD={this.state.activoAD}
                        />
                    </>
                )}
            </ToolkitProvider>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        token: state.usuario.token,
        empresa: state.parametros.empresa
    };
};

export default connect(mapStateToProps)(withRouter(memo(CallCenterItfz)));